import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useSupplierCategoryReducer = () => useSelector((state: ApplicationState) => state.supplierCategory);
